import { Observable } from "rxjs";

export abstract class MailIntegration {

 abstract sendMailMessage(data:any) : Observable<any>
}